var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('SubmissionDetail'),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.results}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }